/**
 * IS TURU OKUMA — tek yer.
 *
 * `jobs` tablosunda is turu IKI kolonda birden duruyor:
 *
 *   job_type      legacy METIN. 11 Haziran 2026'da NOT NULL kisiti
 *                 kaldirildi (1783100000000_drop_jobs_job_type_fk);
 *                 o tarihten sonra acilan islerde BOS.
 *   job_type_id   yeni FK → job_types. Bugun tek dogruluk kaynagi.
 *
 * Metnin bosalmasi sessiz hatalara yol acti: ciro girisinde teknopark
 * isleri "proje bazli" sayilip proje tarihi istedi (2026-10). Okuyucular
 * farkli yedekleme zincirleri yazmisti (job_type_rel, job_type_obj,
 * nesne-veya-metin); hepsi buraya toplandi.
 *
 * SIRA NEDEN BOYLE — METIN ONCE, ILISKI SONRA:
 *
 * Prod'da 74 isin metni 'AR_GE' iken job_type_id'si 'AR_GE Merkezi' adli
 * ture bagli. Iliskiyi one alsaydik o 74 isin gorunen turu bir anda
 * degisirdi; ada gore dallanan kod (JobStatusUpdateModal'daki
 * `case 'AR_GE'`, auto-flow-sync kapsam eslestirmesi) baska yola saparcdi.
 * Metin doluyken ona guveniyoruz — bugunku davranis aynen korunuyor.
 * Iliski yalnizca metin BOS oldugunda devreye giriyor; asil duzeltilen
 * durum da bu.
 *
 * O 74 satirlik tutarsizlik AYRI bir veri konusu; hangisinin dogru
 * oldugu burada verilecek bir karar degil.
 */

/** Isin tur ADI. Hicbiri yoksa null. */
export const jobTypeName = (job) => {
  if (!job) return null;
  const metin = typeof job.job_type === 'string' ? job.job_type : null;
  if (metin) return metin;
  return job.job_type_rel?.name
    || job.job_type_obj?.name
    // useJobs.transformData `job_type`i iliski NESNESINE cevirebiliyor.
    || (typeof job.job_type === 'object' ? job.job_type?.name : null)
    || null;
};

/**
 * Is PROJE BAZLI mi — proje baslangic/bitis tarihi kavrami var mi.
 *
 * Burada sira TERS: once `is_project_based` BAYRAGI, sonra ad. Cunku bu
 * bir EVET/HAYIR verisi, ad degil; veritabani bayragi dogrudan cevabi
 * tasiyor ve sirket Ayarlar'dan yeni tur ekledignde de dogru kalir.
 * Ad bazli yedek yalnizca iliski cekilmemisse devreye girer.
 */
const PROJE_BAZLI_ADLAR = new Set(['TUBITAK', 'ULUSLARARASI']);

export const jobTypeIsProjectBased = (job) => {
  const bayrak = job?.job_type_rel?.is_project_based
    ?? job?.job_type_obj?.is_project_based
    ?? (typeof job?.job_type === 'object' ? job?.job_type?.is_project_based : null)
    ?? job?.contract?.contract_subject?.is_project_based;
  if (typeof bayrak === 'boolean') return bayrak;
  const ad = jobTypeName(job);
  return ad ? PROJE_BAZLI_ADLAR.has(String(ad).toUpperCase()) : false;
};
